(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rise-fs-bar')) return;

    class RiseFsBar extends HTMLElement {
      static get observedAttributes() { return ['data-total']; }

      connectedCallback() {
        this.render();
        if (this.dataset.watch === 'true' && !this._watching) {
          this._watching = true;
          this.watch();
        }
      }

      attributeChangedCallback() { this.render(); }

      rate() {
        var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
        return r > 0 ? r : 1;
      }

      fmt(cents) {
        var cur = this.dataset.currency || 'AUD';
        var v = cents / 100;
        var whole = Math.abs(v - Math.round(v)) < 0.005;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency', currency: cur,
            minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
          }).format(v);
        } catch (e) { return cur + ' ' + v.toFixed(2); }
      }

      render() {
        var aud = parseFloat(this.dataset.aud || '0');
        if (!aud) return;
        var total = parseInt(this.dataset.total || '0', 10) || 0;
        var same = this.dataset.currency === this.dataset.shopCurrency;
        var threshold = same ? Math.round(aud * 100) : Math.ceil(aud * this.rate()) * 100;
        var remaining = Math.max(0, threshold - total);
        var pct = Math.min(100, Math.round(total * 100 / threshold));

        var msg = this.querySelector('[data-fs-message]');
        var fill = this.querySelector('[data-fs-fill]');
        var track = this.querySelector('[role=progressbar]');
        if (msg) {
          msg.textContent = '';
          if (remaining > 0) {
            var parts = (this.dataset.msgRemaining || '').split('{amount}');
            msg.appendChild(document.createTextNode(parts[0] || ''));
            var s = document.createElement('strong');
            s.textContent = this.fmt(remaining);
            msg.appendChild(s);
            msg.appendChild(document.createTextNode(parts.slice(1).join('{amount}')));
          } else {
            msg.textContent = this.dataset.msgDone || '';
          }
        }
        if (fill) fill.style.width = pct + '%';
        if (track) track.setAttribute('aria-valuenow', String(pct));
        this.classList.toggle('free-shipping-bar--complete', remaining === 0);
        this.hidden = false;
      }

      async refresh() {
        try {
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var c = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          this.dataset.total = String(c.total_price);
        } catch (e) {}
      }

      async watch() {
        var self = this;
        try {
          var mod = await import('@shopify/events');
          document.addEventListener(mod.StandardEvents.cartLinesUpdate, function (e) {
            var p = (e && e.promise) || Promise.resolve();
            p.then(function () { self.refresh(); }, function () { self.refresh(); });
          });
        } catch (e) {}
        document.addEventListener('rise:cart-changed', function () { self.refresh(); });
      }
    }

    customElements.define('rise-fs-bar', RiseFsBar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rise-gwp-bar"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('rise-gwp-bar')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function rate() { var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  function th(aud, same) { return same ? Math.round(aud * 100) : Math.ceil(aud * rate()) * 100; }
  function fmt(c, cur) {
    var v = c / 100, w = Math.abs(v - Math.round(v)) < 0.005;
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur, currencyDisplay: cur === 'AUD' ? 'symbol' : 'narrowSymbol', minimumFractionDigits: w ? 0 : 2, maximumFractionDigits: w ? 0 : 2 }).format(v).replace(/^\$/, cur === 'AUD' ? 'A$' : '$'); }
    catch (e) { return cur + ' ' + v.toFixed(2); }
  }

  class RiseGwpBar extends HTMLElement {
    connectedCallback() { this.render(); RiseGwp.check(this); }
    render() {
      var d = this.dataset, cur = d.currency, same = cur === d.shopCurrency;
      var total = parseInt(d.total, 10) || 0;
      var g = th(parseFloat(d.gwp), same), f = th(parseFloat(d.fs), same);
      var msg = this.querySelector('[data-msg]'), fill = this.querySelector('[data-fill]');
      var html, target;
      var b = function (c) { return '<strong>' + fmt(c, cur) + '</strong>'; };
      if (f === g) {
        target = g;
        html = total >= g ? "You've unlocked free shipping + a free skull cap" : b(g - total) + ' away from free shipping + a free skull cap';
      } else if (f < g) {               // AU/NZ/UK: free shipping already comes first
        target = total < f ? f : g;
        html = total < f ? b(f - total) + ' away from free shipping'
             : total < g ? 'Free shipping unlocked · ' + b(g - total) + ' away from a free skull cap'
             : "You've unlocked free shipping + a free skull cap";
      } else {                          // rest of world: cap first, shipping at A$400
        target = total < g ? g : f;
        html = total < g ? b(g - total) + ' away from a free skull cap'
             : total < f ? 'Free skull cap unlocked · ' + b(f - total) + ' away from free shipping'
             : "You've unlocked free shipping + a free skull cap";
      }
      msg.innerHTML = html;
      var pct = Math.min(100, Math.round(total * 100 / target));
      fill.style.width = pct + '%';
      this.querySelector('[role=progressbar]').setAttribute('aria-valuenow', pct);
      this.classList.toggle('rgb--done', total >= Math.max(f, g));
      this.hidden = false;
    }
  }

  // Auto-add / auto-remove the gift. Loop guards: one request at a time,
  // max 4 changes per page view, and if the shopper removes the gift
  // themselves we respect it for the session.
  var RiseGwp = window.RiseGwp = {
    busy: false, ops: 0,
    check: function (bar) {
      var self = this; if (self.busy || self.ops >= 4) return;
      self.busy = true;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var vid = parseInt(bar.dataset.variant, 10);
        var same = cart.currency === bar.dataset.shopCurrency;
        var gift = cart.items.filter(function (i) { return i.variant_id === vid; });
        var auto = gift.filter(function (i) { return i.properties && i.properties._gwp; });
        var total = cart.items_subtotal_price - gift.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var over = total >= th(parseFloat(bar.dataset.gwp), same);
        var declined = sessionStorage.getItem('rise-gwp-declined') === '1';
        if (sessionStorage.getItem('rise-gwp-added') === '1' && over && !gift.length) { sessionStorage.setItem('rise-gwp-declined', '1'); declined = true; }
        if (over && !gift.length && !declined && bar.dataset.available === 'true') {
          return self.post('add.js', { items: [{ id: vid, quantity: 1, properties: { _gwp: '1' } }] }).then(function () { sessionStorage.setItem('rise-gwp-added', '1'); });
        }
        if (!over && auto.length) {
          var u = {}; auto.forEach(function (i) { u[i.key] = 0; });
          return self.post('update.js', { updates: u }).then(function () { sessionStorage.removeItem('rise-gwp-added'); });
        }
      }).catch(function () {}).finally(function () { self.busy = false; });
    },
    post: function (path, body) {
      this.ops++;
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (e) { return e.dataset.sectionId; });
      body.sections = ids.join(',');
      return fetch(root + 'cart/' + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (res) {
          var sections = res.sections || {};
          ids.forEach(function (id) {
            var html = sections[id]; if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('cart-items-component'), cur = document.querySelector('cart-items-component[data-section-id="' + id + '"]');
            if (next && cur) cur.replaceWith(next);
          });
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 'rise-gwp', data: { source: 'rise-gwp', itemCount: c.item_count } } }));
            document.dispatchEvent(new CustomEvent('rise:cart-changed'));
          });
        });
    }
  };
  customElements.define('rise-gwp-bar', RiseGwpBar);
})();
  } catch(e) { console.error(e); }
})();

})();
